
import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from "recharts";

const ChamadosChart = ({ data }) => {
  if (!data || data.length === 0) return <p>Nenhum dado disponível.</p>;

  const dadosFormatados = data.map((item) => ({
    mes: item.mes.charAt(0).toUpperCase() + item.mes.slice(1, 3), 
    chamados: item.total,
  }));

  return (
    <ResponsiveContainer width="100%" height={200}>
      <BarChart data={dadosFormatados}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="mes" />
        <YAxis allowDecimals={false} />
        <Tooltip />
        <Bar dataKey="chamados" fill="#0a66c2" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ChamadosChart;
